import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

const SaasAdminClientsIndex = React.lazy(() =>
  import('views/app-views/saas-admin/clients')
)
const SaasAdminClientNew = React.lazy(() =>
  import('views/app-views/saas-admin/clients/new')
)
const SaasAdminClientDetail = React.lazy(() =>
  import('views/app-views/saas-admin/clients/detail')
)
const SaasAdminSubscriptionsIndex = React.lazy(() =>
  import("views/app-views/saas-admin/subscriptions")
)

const SaasAdminSubscriptionsDetail = React.lazy(() =>
  import("views/app-views/saas-admin/subscriptions/detail")
)
const SaasAdminDashboard = React.lazy(() =>
  import("views/app-views/saas-admin/dashboard")
)
const AccessProfilesIndex = React.lazy(() =>
  import("views/app-views/settings/access-profiles")
);
const InventoryControl = React.lazy(() =>
  import("views/app-views/inventory/control")
);

const InventoryAssetsStatus = React.lazy(() =>
  import("views/app-views/inventory/assets-status")
);

const OperationsCenter = React.lazy(() =>
  import("views/app-views/operations-center")
);

export const publicRoutes = [
  {
    key: 'login',
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() => import('views/auth-views/authentication/login')),
  },
  {
    key: 'register',
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() => import('views/auth-views/authentication/register')),
  },
  {
    key: 'forgot-password',
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
  },
]

export const protectedRoutes = [
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import('views/app-views/dashboards/default')),
    meta: { perm: 'dashboard.view' },
  },

  {
    key: "operations-center",
    path: `${APP_PREFIX_PATH}/operations-center`,
    component: OperationsCenter,
    meta: {
      perm: "serviceOrders.view",
    },
  },

  // =====================================================
  // OPERAÇÕES - SUBLOCAÇÕES
  // =====================================================

  {
    key: "operations.subrentals",
    path: `${APP_PREFIX_PATH}/operations/subrentals`,
    component: React.lazy(() =>
      import("views/app-views/operations/subrentals")
    ),
    meta: {
      perm: "subrentals.operational.view",
    },
  },

  // ✅ SaaS Admin
  {
    key: "saas-admin-dashboard",
    path: `${APP_PREFIX_PATH}/saas-admin/dashboard`,
    component: SaasAdminDashboard,
    meta: { superAdminOnly: true },
  },
  {
    key: 'saas-admin.clients',
    path: `${APP_PREFIX_PATH}/saas-admin/clients`,
    component: SaasAdminClientsIndex,
    meta: { superAdminOnly: true },
  },
  {
    key: 'saas-admin.clients.new',
    path: `${APP_PREFIX_PATH}/saas-admin/clients/new`,
    component: SaasAdminClientNew,
    meta: { superAdminOnly: true },
  },
  {
    key: 'saas-admin.clients.detail',
    path: `${APP_PREFIX_PATH}/saas-admin/clients/:companyId`,
    component: SaasAdminClientDetail,
    meta: { superAdminOnly: true },
  },
  {
    key: 'saas-plans',
    path: '/app/saas-admin/plans',
    component: React.lazy(() => import('views/app-views/saas-admin/plans')),
  },
  {
    key: "saas-admin.subscriptions",
    path: `${APP_PREFIX_PATH}/saas-admin/subscriptions`,
    component: SaasAdminSubscriptionsIndex,
    meta: { superAdminOnly: true },
  },
  {
    key: "saas-admin.subscriptions.detail",
    path: `${APP_PREFIX_PATH}/saas-admin/subscriptions/:companyId`,
    component: SaasAdminSubscriptionsDetail,
    meta: { superAdminOnly: true },
  },
  {
    key: "saas-admin-invoices",
    path: `${APP_PREFIX_PATH}/saas-admin/invoices`,
    component: React.lazy(() => import("views/app-views/saas-admin/invoices")),
    meta: { superAdminOnly: true },
  },
  {
    key: "saas-admin.profile-templates",
    path: `${APP_PREFIX_PATH}/saas-admin/profile-templates`,
    component: React.lazy(() =>
      import("views/app-views/saas-admin/profile-templates")
    ),
    meta: { superAdminOnly: true },
  },

  {
    key: "settings.access-profiles",
    path: `${APP_PREFIX_PATH}/settings/access-profiles`,
    component: AccessProfilesIndex,
  },

  // ✅ widget público para WordPress / iframe
  {
    key: "public.chat-widget",
    path: "/chat-widget",
    component: React.lazy(() => import("views/public/chat-widget")),
  },

  {
    key: 'people.clients',
    path: `${APP_PREFIX_PATH}/people/clients`,
    component: React.lazy(() => import('views/app-views/people')),
    meta: { perm: 'people.view' },
  },
  {
    key: 'people.suppliers',
    path: `${APP_PREFIX_PATH}/people/suppliers`,
    component: React.lazy(() => import('views/app-views/people')),
    meta: { perm: 'people.view' },
  },
  {
    key: 'people.employees',
    path: `${APP_PREFIX_PATH}/people/employees`,
    component: React.lazy(() => import('views/app-views/people')),
    meta: { perm: 'people.view' },
  },
  {
    key: 'people.freelancers',
    path: `${APP_PREFIX_PATH}/people/freelancers`,
    component: React.lazy(() => import('views/app-views/people')),
    meta: { perm: 'people.view' },
  },
  {
    key: 'people.detail',
    path: `${APP_PREFIX_PATH}/people/:id`,
    component: React.lazy(() => import('views/app-views/people/detail')),
    meta: { perm: 'people.view' },
  },

  {
    key: 'quotes.list',
    path: `${APP_PREFIX_PATH}/quotes`,
    component: React.lazy(() => import('views/app-views/quotes')),
    meta: { perm: 'quotes.view' },
  },
  {
    key: 'quotes.detail',
    path: `${APP_PREFIX_PATH}/quotes/:id`,
    component: React.lazy(() => import('views/app-views/quotes/detail')),
    meta: { perm: 'quotes.view' },
  },
  {
    key: 'quotes.new',
    path: `${APP_PREFIX_PATH}/quotes/new`,
    component: React.lazy(() => import('views/app-views/quotes/new')),
    meta: { perm: 'quotes.create' },
  },

  {
    key: 'crm.leads',
    path: `${APP_PREFIX_PATH}/crm/leads`,
    component: React.lazy(() => import('views/app-views/crm/leads')),
    meta: { perm: 'crm.view' },
  },

  {
    key: 'crm.pipeline',
    path: `${APP_PREFIX_PATH}/crm/pipeline`,
    component: React.lazy(() => import('views/app-views/crm/pipeline')),
    meta: { perm: 'crm.view' },
  },
  {
    key: "crm.flows",
    path: `${APP_PREFIX_PATH}/crm/flows`,
    component: React.lazy(() => import("views/app-views/crm/flows")),
    meta: { perm: "crm.view" },
  },
  {
    key: "crm.flows.edit",
    path: `${APP_PREFIX_PATH}/crm/flows/:id`,
    component: React.lazy(() => import("views/app-views/crm/flows/editor")),
    meta: { perm: "crm.view" },
  },
  {
    key: 'crm.conversations',
    path: `${APP_PREFIX_PATH}/crm/conversations`,
    component: React.lazy(() => import('views/app-views/crm/conversations')),
    meta: { perm: 'crm.view' },
  },
  {
    key: 'crm.chat.analytics',
    path: `${APP_PREFIX_PATH}/crm/chat/analytics`,
    component: React.lazy(() => import('views/app-views/crm/chat/analytics')),
    meta: { perm: 'crm.view' },
  },
  {
    key: "crm.chat.integrations",
    path: `${APP_PREFIX_PATH}/crm/chat/integrations`,
    component: React.lazy(() => import("views/app-views/crm/chat/integrations")),
    meta: { perm: "crm.view" },
  },
  {
    key: "crm.chat.settings",
    path: `${APP_PREFIX_PATH}/crm/chat/settings`,
    component: React.lazy(() => import("views/app-views/crm/chat/settings")),
    meta: { perm: "crm.view" },
  },

  {
    key: 'company.settings',
    path: `${APP_PREFIX_PATH}/company`,
    component: React.lazy(() => import('views/app-views/company')),
    meta: { perm: 'company.manage' },
  },
  {
    key: "chat-widget-settings",
    path: "/app/chat-widget/settings",
    component: React.lazy(() =>
      import("views/app-views/chat-widget/settings")
    ),
    meta: {
      title: "Configurações do Chat",
      breadcrumb: true,
      perm: "chat.widget.settings",
    },
  },

  // LISTA EMPRESAS
  {
    key: 'company.list',
    path: `${APP_PREFIX_PATH}/company`,
    component: React.lazy(() => import('views/app-views/company')),
    meta: {
      perm: 'company.manage',
    },
  },

  // EDITAR EMPRESA
  {
    key: 'company.edit',
    path: `${APP_PREFIX_PATH}/company/:companyId`,
    component: React.lazy(() => import('views/app-views/company')),
    meta: {
      perm: 'company.manage',
    },
  },

  {
    key: 'users.list',
    path: `${APP_PREFIX_PATH}/users`,
    component: React.lazy(() => import('views/app-views/users')),
    meta: { perm: 'users.manage' },
  },
  {
    key: 'users.new',
    path: `${APP_PREFIX_PATH}/users/new`,
    component: React.lazy(() => import('views/app-views/users/new')),
    meta: { perm: 'users.manage' },
  },
  {
    key: 'users.edit',
    path: `${APP_PREFIX_PATH}/users/:id`,
    component: React.lazy(() => import('views/app-views/users/edit')),
    meta: { perm: 'users.manage' },
  },

  {
    key: 'profile',
    path: `${APP_PREFIX_PATH}/profile`,
    component: React.lazy(() => import('views/app-views/profile')),
    authority: [],
  },

  // =========================
  // PRODUTOS
  // =========================
  {
    key: 'products.list',
    path: `${APP_PREFIX_PATH}/products`,
    component: React.lazy(() => import('views/app-views/products')),
    meta: { perm: 'products.view' },
  },
  {
    key: 'products.own',
    path: `${APP_PREFIX_PATH}/products/own`,
    component: React.lazy(() => import('views/app-views/products')),
    meta: { perm: 'products.view' },
  },
  {
    key: 'products.subrental',
    path: `${APP_PREFIX_PATH}/products/subrental`,
    component: React.lazy(() => import('views/app-views/products')),
    meta: { perm: 'products.view' },
  },
  {
    key: 'products.new',
    path: `${APP_PREFIX_PATH}/products/new`,
    component: React.lazy(() => import('views/app-views/products/new')),
    meta: { perm: 'products.create' },
  },
  {
    key: 'products.detail',
    path: `${APP_PREFIX_PATH}/products/:id`,
    component: React.lazy(() => import('views/app-views/products/detail')),
    meta: { perm: 'products.view' },
  },
  {
    key: 'products.edit',
    path: `${APP_PREFIX_PATH}/products/:id/edit`,
    component: React.lazy(() => import('views/app-views/products/edit')),
    meta: { perm: 'products.update' },
  },
  {
    key: 'products.cadastros',
    path: `${APP_PREFIX_PATH}/products/cadastros`,
    component: React.lazy(() => import('views/app-views/products/cadastros')),
    meta: { perm: 'products.manage' },
  },

  {
    key: 'reports.top-products',
    path: `${APP_PREFIX_PATH}/reports/top-products`,
    component: React.lazy(() => import('views/app-views/reports/top-products')),
  },

  // =========================
  // TABELA DE PREÇOS
  // =========================
  {
    key: 'priceTables.list',
    path: `${APP_PREFIX_PATH}/price-tables`,
    component: React.lazy(() => import('views/app-views/price-tables')),
    meta: { perm: 'products.priceTables.view' },
  },
  {
    key: 'priceTables.new',
    path: `${APP_PREFIX_PATH}/price-tables/new`,
    component: React.lazy(() => import('views/app-views/price-tables/form')),
    meta: { perm: 'products.priceTables.update' },
  },
  {
    key: 'priceTables.detail',
    path: `${APP_PREFIX_PATH}/price-tables/:id`,
    component: React.lazy(() => import('views/app-views/price-tables/detail')),
    meta: { perm: 'products.priceTables.view' },
  },

  // =========================
  // FORNECEDORES / SUBLOCAÇÃO
  // =========================
  {
    key: 'products.suppliers',
    path: `${APP_PREFIX_PATH}/products/:id/suppliers`,
    component: React.lazy(() => import('views/app-views/products/suppliers')),
    meta: { perm: 'products.suppliers.view' },
  },

  // =========================
  // ✅ FINANCEIRO
  // =========================
  {
    key: 'finance.receivables',
    path: `${APP_PREFIX_PATH}/finance/receivables`,
    component: React.lazy(() => import('views/app-views/finance/receivables')),
    meta: { perm: 'finance.view' },
  },
  {
    key: 'finance.payables',
    path: `${APP_PREFIX_PATH}/finance/payables`,
    component: React.lazy(() => import('views/app-views/finance/payables')),
    meta: { perm: 'finance.view' },
  },
  {
    key: 'finance.receipts',
    path: `${APP_PREFIX_PATH}/finance/receipts`,
    component: React.lazy(() => import('views/app-views/finance/receipts')),
    meta: { perm: 'finance.view' },
  },
  {
    key: 'finance.settings',
    path: `${APP_PREFIX_PATH}/finance/settings`,
    component: React.lazy(() => import('views/app-views/finance/settings')),
    meta: { perm: 'finance.manage' },
  },
  {
    key: 'finance.cashflow',
    path: `${APP_PREFIX_PATH}/finance/cashflow`,
    component: React.lazy(() => import('views/app-views/finance/cashflow')),
    meta: { perm: 'finance.view' },
  },

  // =========================
  // ✅ CONTRATOS (FINANCEIRO)
  // =========================
  {
    key: 'finance.contracts',
    path: `${APP_PREFIX_PATH}/finance/contracts`,
    component: React.lazy(() => import('views/app-views/finance/contracts')),
    meta: { perm: 'finance.view' },
  },
  {
    key: 'finance.contract-templates',
    path: `${APP_PREFIX_PATH}/finance/contracts/templates`,
    component: React.lazy(() => import('views/app-views/finance/contracts/templates')),
    meta: { perm: 'finance.view' },
  },
  {
    key: 'finance.contract-clauses',
    path: `${APP_PREFIX_PATH}/finance/contracts/clauses`,
    component: React.lazy(() => import('views/app-views/finance/contracts/clauses')),
    meta: { perm: 'finance.view' },
  },

  // =========================
  // ✅ SERVICE ORDERS (OS)
  // =========================
  {
    key: 'serviceOrders.list',
    path: `${APP_PREFIX_PATH}/service-orders`,
    component: React.lazy(() => import('views/app-views/service-orders')),
    meta: { perm: 'serviceOrders.view' },
  },
  {
    key: 'serviceOrders.detail',
    path: `${APP_PREFIX_PATH}/service-orders/:id`,
    component: React.lazy(() => import('views/app-views/service-orders/detail')),
    meta: { perm: 'serviceOrders.view' },
  },

  {
    key: 'serviceOrders.fieldExecution',
    path: `${APP_PREFIX_PATH}/service-orders/:id/field-execution`,
    component: React.lazy(() =>
      import('views/app-views/service-orders/field-execution/ServiceOrderFieldExecutionPage')
    ),
    meta: { perm: 'serviceOrders.view' },
  },

  {
    key: 'inventory.return-alerts',
    path: `${APP_PREFIX_PATH}/inventory/return-alerts`,
    component: React.lazy(() => import('views/app-views/inventory/return-alerts')),
    meta: { perm: 'products.view' },
  },
  {
    key: 'inventory.control',
    path: `${APP_PREFIX_PATH}/inventory/control`,
    component: React.lazy(() => import('views/app-views/inventory/control')),
    meta: { perm: 'products.view' },
  },
  {
    key: 'inventory.assets-status',
    path: `${APP_PREFIX_PATH}/inventory/assets-status`,
    component: React.lazy(() => import('views/app-views/inventory/assets-status')),
    meta: { perm: 'inventory.view' },
  },


  // =========================
  // ✅ OPERAÇÕES / CHECKLIST
  // =========================
  {
    key: 'operations.checklists',
    path: `${APP_PREFIX_PATH}/operations/checklists`,
    component: React.lazy(() => import('views/app-views/checklists')),
    meta: { perm: 'checklists.view' },
  },
  {
    key: 'operations.checklists.detail',
    path: `${APP_PREFIX_PATH}/operations/checklists/:id`,
    component: React.lazy(() => import('views/app-views/checklists/detail')),
    meta: { perm: 'checklists.view' },
  },
  // =====================================================
  // SUBLOCAÇÃO - MÓDULO INDEPENDENTE
  // =====================================================

  {
    key: 'subrentals',
    path: `${APP_PREFIX_PATH}/subrentals`,
    component: React.lazy(() =>
      import('views/app-views/subrentals')
    ),
    meta: { perm: 'subrentals.view' },
  },

  {
    key: 'subrentals.quotes',
    path: `${APP_PREFIX_PATH}/subrentals/quotes`,
    component: React.lazy(() =>
      import('views/app-views/subrentals/quotes')
    ),
    meta: { perm: 'subrentals.view' },
  },
  {
    key: 'subrentals.quotes.compare',
    path: `${APP_PREFIX_PATH}/subrentals/quotes/compare/:requestId`,
    component: React.lazy(() =>
      import('views/app-views/subrentals/quotes/compare')
    ),
    meta: { perm: 'subrentals.view' },
  },

  //===========================
  // ✅ PROJETOS
  //===========================
  {
    key: "projects",
    path: "/app/projects",
    component: React.lazy(() => import("views/app-views/projects")),
    authority: [],
  },
  {
    key: "project-details",
    path: "/app/projects/:id",
    component: React.lazy(() => import("views/app-views/projects/details")),
    authority: [],
  },

  // =========================
  // ✅ RADAR
  // =========================
  {
    key: "radar",
    path: `/app/radar`,
    component: React.lazy(() => import("views/app-views/radar")),
  },

  // =========================
  // ✅ FILIAL
  // =========================
  {
    key: "branches.list",
    path: `${APP_PREFIX_PATH}/branches`,
    component: React.lazy(() => import("views/app-views/branches")),
    meta: { perm: "company.manage" },
  },
  {
    key: "branches.new",
    path: `${APP_PREFIX_PATH}/branches/new`,
    component: React.lazy(() => import("views/app-views/branches/BranchForm")),
    meta: { perm: "company.manage" },
  },
  {
    key: "branches.edit",
    path: `${APP_PREFIX_PATH}/branches/:id`,
    component: React.lazy(() => import("views/app-views/branches/BranchForm")),
    meta: { perm: "company.manage" },
  },

  // =========================
  // ✅ MULTI-EMPRESA (SELEÇÃO)
  // =========================
  {
    key: 'auth.select-company',
    path: `${AUTH_PREFIX_PATH}/select-company`,
    component: React.lazy(() =>
      import('views/auth-views/authentication/select-company')
    ),
  },

  // =========================
  // ✅ COMPRAS
  // =========================
  {
    key: 'purchases.orders',
    path: `${APP_PREFIX_PATH}/purchases/orders`,
    component: React.lazy(() => import('views/app-views/purchases/orders')),
    meta: { perm: 'purchases.view' },
  },
  {
    key: 'purchases.receipts',
    path: `${APP_PREFIX_PATH}/purchases/receipts`,
    component: React.lazy(() => import('views/app-views/purchases/receipts')),
    meta: { perm: 'purchases.view' },
  },
  {
    key: 'purchases.orders.detail',
    path: `${APP_PREFIX_PATH}/purchases/orders/:id`,
    component: React.lazy(() => import('views/app-views/purchases/orders/detail')),
    meta: { perm: 'purchases.view' },
  },
  {
    key: 'purchases.requests',
    path: `${APP_PREFIX_PATH}/purchases/requests`,
    component: React.lazy(() => import('views/app-views/purchases/requests')),
    meta: { perm: 'purchases.view' },
  },
  {
    key: 'purchases.quotes',
    path: `${APP_PREFIX_PATH}/purchases/quotes`,
    component: React.lazy(() => import('views/app-views/purchases/quotes')),
    meta: { perm: 'purchases.view' },
  },
  {
    key: 'purchases.quotes.compare',
    path: `${APP_PREFIX_PATH}/purchases/quotes/compare/:requestId`,
    component: React.lazy(() => import('views/app-views/purchases/quotes/compare')),
    meta: { perm: 'purchases.view' },
  },
  {
    key: 'purchases.requests.detail',
    path: `${APP_PREFIX_PATH}/purchases/requests/:id`,
    component: React.lazy(() => import('views/app-views/purchases/requests/detail')),
    meta: { perm: 'purchases.view' },
  },
  {
    key: 'purchases.dashboard',
    path: `${APP_PREFIX_PATH}/purchases/dashboard`,
    component: React.lazy(() => import('views/app-views/purchases/dashboard')),
    meta: { perm: 'purchases.view' },
  },
  // =========================
  // ✅ MODULO PEDIDOS
  // =========================

  {
    key: "customer-orders",
    path: `${APP_PREFIX_PATH}/customer-orders`,
    component: React.lazy(() => import("views/app-views/customer-orders")),
    meta: {
      perm: "customer_orders.view",
    },
  },


  // =========================
  // ✅ INTEGRAÇÕES / WOOCOMMERCE
  // =========================
  {
    key: 'integrations.woocommerce.stores',
    path: `${APP_PREFIX_PATH}/integrations/woocommerce`,
    component: React.lazy(() => import('views/app-views/integrations/woocommerce')),
    meta: { perm: 'integrations.woocommerce.stores.view' },
  },
  {
    key: 'integrations.woocommerce.orders',
    path: `${APP_PREFIX_PATH}/integrations/woocommerce/orders`,
    component: React.lazy(() => import('views/app-views/integrations/woocommerce/orders')),
    meta: { perm: 'integrations.woocommerce.orders.view' },
  },
  {
    key: 'integrations.woocommerce.logs',
    path: `${APP_PREFIX_PATH}/integrations/woocommerce/logs`,
    component: React.lazy(() => import('views/app-views/integrations/woocommerce/logs')),
    meta: { perm: 'integrations.woocommerce.logs.view' },
  },
  {
    key: 'integrations.woocommerce.product-links',
    path: `${APP_PREFIX_PATH}/integrations/woocommerce/product-links`,
    component: React.lazy(() => import('views/app-views/integrations/woocommerce/product-links')),
    meta: { perm: 'integrations.woocommerce.productLinks.view' },
  },
  {
    key: 'integrations.woocommerce.unmapped-items',
    path: `${APP_PREFIX_PATH}/integrations/woocommerce/unmapped-items`,
    component: React.lazy(() => import('views/app-views/integrations/woocommerce/unmapped-items')),
    meta: { perm: 'integrations.woocommerce.unmappedItems.view' },
  },
  {
    key: 'integrations.woocommerce.catalog-products',
    path: `${APP_PREFIX_PATH}/integrations/woocommerce/catalog-products`,
    component: React.lazy(() =>
      import('views/app-views/integrations/woocommerce/catalog-products')
    ),
    meta: { perm: 'integrations.woocommerce.catalogProducts.view' },
  },

  // =========================
  // ✅ ECOMMERCE
  // =========================
  {
    key: 'ecommerce.dashboard',
    path: `${APP_PREFIX_PATH}/ecommerce/dashboard`,
    component: React.lazy(() => import('views/app-views/ecommerce/dashboard')),
    meta: { perm: 'ecommerce.dashboard.view' },
  },
  {
    key: 'ecommerce.orders',
    path: `${APP_PREFIX_PATH}/ecommerce/orders`,
    component: React.lazy(() => import('views/app-views/ecommerce/orders')),
    meta: { perm: 'ecommerce.orders.view' },
  },
  {
    key: 'ecommerce.products',
    path: `${APP_PREFIX_PATH}/ecommerce/products`,
    component: React.lazy(() => import('views/app-views/ecommerce/products')),
    meta: { perm: 'ecommerce.products.view' },
  },
  {
    key: 'ecommerce.customers',
    path: `${APP_PREFIX_PATH}/ecommerce/customers`,
    component: React.lazy(() => import('views/app-views/ecommerce/customers')),
    meta: { perm: 'ecommerce.customers.view' },
  },
  {
    key: 'ecommerce.integrations',
    path: `${APP_PREFIX_PATH}/ecommerce/integrations`,
    component: React.lazy(() => import('views/app-views/ecommerce/integrations')),
    meta: { perm: 'ecommerce.integrations.view' },
  },
  {
    key: 'ecommerce.fiscal',
    path: `${APP_PREFIX_PATH}/ecommerce/fiscal`,
    component: React.lazy(() => import('views/app-views/ecommerce/fiscal')),
    meta: { perm: 'ecommerce.fiscal.view' },
  },
  {
    key: 'ecommerce.finance',
    path: `${APP_PREFIX_PATH}/ecommerce/finance`,
    component: React.lazy(() => import('views/app-views/ecommerce/finance')),
    meta: { perm: 'ecommerce.finance.view' },
  },
  // =========================
  // ✅ ASSISTÊNCIA TÉCNICA / MANUTENÇÃO
  // =========================
  {
    key: 'maintenance.dashboard',
    path: `${APP_PREFIX_PATH}/maintenance`,
    component: React.lazy(() => import('views/app-views/maintenance/workshop')),
    meta: { perm: 'products.view' },
  },
  {
    key: 'maintenance.asset-detail',
    path: `${APP_PREFIX_PATH}/maintenance/assets/:id`,
    component: React.lazy(() => import('views/app-views/maintenance/asset-detail')),
    meta: { perm: 'products.view' },
  },
  {
    key: 'maintenance.checklist-templates',
    path: `${APP_PREFIX_PATH}/maintenance/checklist-templates`,
    component: React.lazy(() =>
      import('views/app-views/maintenance/checklist-templates')
    ),
    meta: { perm: 'products.view' },
  },
  {
    key: "maintenance.new",
    path: `${APP_PREFIX_PATH}/maintenance/new`,
    component: React.lazy(() => import("views/app-views/maintenance/new")),
    meta: { perm: "products.view" },
  },
  {
    key: "maintenance.workshop",
    path: `${APP_PREFIX_PATH}/maintenance/workshop`,
    component: React.lazy(() => import("views/app-views/maintenance/workshop")),
    meta: { perm: "products.view" },
  },
  {
    key: "maintenance.detail",
    path: `${APP_PREFIX_PATH}/maintenance/:id`,
    component: React.lazy(() =>
      import("views/app-views/maintenance/detail.js")
    ),
    meta: { perm: "products.view" },
  },
  {
    key: "maintenance.parts",
    path: `${APP_PREFIX_PATH}/maintenance/parts`,
    component: React.lazy(() =>
      import("views/app-views/maintenance/parts")
    ),
  },
]